WiseMetering.Views.ShowMeasurablConfiguration = WiseMetering.Views.Modal.Show.extend({
    className: 'mbx-info text-left',
    template: 'templates/integration_configurations/measurabl/show',
    title: () => i18next.t('modal.title.integration_configurations.show')

    // edit: function() {
    //     new WiseMetering.Views.EditMeasurablConfiguration({ model: this.model });
    // }
});
